// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1qGG7","left":"styles_left__JIZ2Q","right":"styles_right__2q-9L","alert":"styles_alert__gbYKn"};